import React from "react";
import styled from "styled-components";
import ContactForm from "../components/ContactForm";
import BookButton from "../components/BookButton";
import { PageHeadline, PageSubtext } from "../components/Typography";
import { typography } from "../styles/designSystem";

const ContactWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 6rem 2rem 4rem;

    @media (max-width: 768px) {
        padding: 4rem 1.5rem 3rem;
    }
`;

const HeaderSection = styled.div`
    max-width: 800px;
    margin: 0 auto 4rem;
    text-align: left;

    @media (max-width: 768px) {
        margin-bottom: 3rem;
    }
`;

const Title = styled(PageHeadline)`
    margin: 0 0 1.5rem;
`;

const Blurb = styled(PageSubtext)`
    text-align: left;
    margin-bottom: 2rem;
    max-width: 100%;

    p {
        margin: 0 0 1rem;

        &:last-child {
            margin-bottom: 0;
        }
    }

    strong {
        color: ${({ theme }) => theme.text};
        font-weight: ${typography.fontWeight.semibold};
    }
`;

const FormContainer = styled.div`
    max-width: 800px;
    margin: 0 auto;
`;

const BookingSection = styled.div`
    max-width: 800px;
    margin: 0 auto 4rem;

    h3 {
        font-size: 1.5rem;
        font-weight: 700;
        margin: 0 0 0.5rem;
        color: ${({ theme }) => theme.text};
    }

    p {
        color: ${({ theme }) => theme.subtleText};
        margin: 0 0 1.5rem;
        line-height: 1.6;
    }

    @media (max-width: 768px) {
        margin-bottom: 3rem;
    }
`;

const BookingButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
`;

const Divider = styled.hr`
    max-width: 800px;
    margin: 0 auto 2.5rem;
    border: none;
    border-top: 1px solid ${({ theme }) => theme.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'};
`;

const Contact = () => {
    return (
        <ContactWrapper>
            <HeaderSection>
                <Title>Let's Connect</Title>
                <Blurb>
                    <p>
                        I'm currently <strong>open to new opportunities</strong> and would love to hear from you.
                        Whether you're interested in discussing a potential role, reviewing my portfolio in depth,
                        or exploring how I approach design systems and accessibility—I'm here to chat.
                    </p>
                    <p>
                        Book a time below to schedule an interview or a portfolio review—you'll get a
                        calendar invite with a video link automatically. Prefer email? Use the form instead
                        and I'll respond as quickly as possible.
                    </p>
                </Blurb>
            </HeaderSection>

            <BookingSection>
                <h3>Book a time</h3>
                <p>Pick a slot that works for you. I'll confirm with a calendar invite and meeting link.</p>
                <BookingButtons>
                    <BookButton event="15min" variant="primary">Book a 15-min Intro</BookButton>
                    <BookButton event="30min" variant="ghost">Book a 30-min Interview</BookButton>
                </BookingButtons>
            </BookingSection>

            <Divider />

            <FormContainer>
                <ContactForm />
            </FormContainer>
        </ContactWrapper>
    );
};

export default Contact;